import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Card, CardContent } from '@/components/ui/card';
import { Search, FileText, Shield, CheckCircle } from 'lucide-react';

const processSteps = [
  {
    icon: Search,
    number: 1,
    title: 'Submit Your Details',
    description: 'Provide us with your brand name, logo, and basic business information through our secure online form.'
  },
  {
    icon: FileText,
    number: 2,
    title: 'We Handle the Filing',
    description: 'Our experts conduct a trademark search, prepare your application, and file it with the USPTO accurately and efficiently.'
  },
  {
    icon: Shield,
    number: 3,
    title: 'Get Official Protection',
    description: 'Once approved, your trademark is officially registered, giving you exclusive legal rights and nationwide brand protection.'
  }
];

export const Process = () => {
  const mobileSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    pauseOnHover: true
  };

  return (
    <section className="py-20 md:py-32 bg-brand-navy">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-16">
          <p className="text-blue-400 font-semibold mb-2 uppercase tracking-wide">SIMPLE PROCESS STEPS</p>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4">
            Three Steps To Protect Your Brand's Identity
          </h2>
        </div>

        {/* Desktop Grid View */}
        <div className="hidden md:grid md:grid-cols-3 gap-8">
          {processSteps.map((step, idx) => (
            <div key={idx} className="relative">
              <Card className="border-0 bg-brand-navy-card shadow-xl transition-all duration-300 border border-blue-900/30 hover:border-blue-500 hover:shadow-[0_0_30px_rgba(59,130,246,0.5)] hover:-translate-y-2 group">
                <CardContent className="p-8">
                  <div className="w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-blue-500/20 transition-colors">
                    <step.icon className="w-8 h-8 text-blue-400 group-hover:text-blue-300 transition-colors" />
                  </div>
                  <h3 className="text-xl font-heading font-bold text-white mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </CardContent>
              </Card>
              {idx < processSteps.length - 1 && (
                <div className="absolute top-1/2 -right-4 w-8 h-0.5 bg-blue-500/30 hidden lg:block" />
              )}
            </div>
          ))}
        </div>

        {/* Mobile Slider View */}
        <div className="md:hidden">
          <Slider {...mobileSliderSettings}>
            {processSteps.map((step, idx) => (
              <div key={idx} className="px-2">
                <Card className="border-0 bg-brand-navy-card shadow-lg border border-blue-900/30 mx-auto max-w-sm">
                  <CardContent className="p-8">
                    <div className="text-6xl font-bold text-blue-500/20 mb-4">{step.number}</div>
                    <div className="w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mb-6">
                      <step.icon className="w-8 h-8 text-blue-400" />
                    </div>
                    <h3 className="text-xl font-heading font-bold text-white mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};